import { useMutation, useQuery, useQueryClient } from "react-query";

import { OnSuccess, UseGetProductImageParams } from "../types";

import {
  addProduct,
  applyImageLinkToProduct,
  editProduct,
  getMeasureUnits,
  getNDS,
  getProductImage,
  uploadProductImage,
} from "./index";

const useSuccess = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-products"] });
    queryClient.invalidateQueries({ queryKey: ["get-products-infinite"] });
  };
};

export const useGetMeasureUnits = () => {
  return useQuery(["get-nds"], getMeasureUnits);
};

export const useGetNDS = () => {
  return useQuery(["get-measure-units"], getNDS);
};

export const useAddProduct = ({ onSuccess }: { onSuccess?: OnSuccess }) => {
  return useMutation(["add-product"], addProduct, {
    onSuccess,
  });
};

export const useEditProduct = ({ onSuccess }: { onSuccess?: OnSuccess }) => {
  const onSuccessInside = useSuccess();

  return useMutation(["edit-product"], editProduct, {
    onSuccess: onSuccess || onSuccessInside,
  });
};

export const useUploadProductImage = ({
  onSuccess,
}: {
  onSuccess?: OnSuccess;
}) => {
  return useMutation(["upload-product-image"], uploadProductImage, {
    onSuccess,
  });
};

export const useApplyImageLinkToProduct = ({
  onSuccess,
}: {
  onSuccess?: OnSuccess;
}) => {
  return useMutation(["apply-image-link-to-product"], applyImageLinkToProduct, {
    onSuccess,
  });
};

export const useGetProductImage = ({
  onSuccess,
  itemId,
  enabled,
}: UseGetProductImageParams) => {
  return useQuery(
    ["get-product-image", itemId],
    () => getProductImage(itemId),
    {
      onSuccess,
      enabled,
    }
  );
};
